import React from "react";
import "./RadioButton.scss";

const RadioButton = ({
  id,
  value,
  label,
  name,
  isChecked,
  onChange,
  disabled,
}) => {
  return (
    <div id="radio-btn">
      <input
        className="radio-input"
        type="radio"
        name={name}
        id={`radio-${id}`} // Ensure unique ID
        value={value}
        checked={isChecked}
        disabled={disabled}
        onChange={() => onChange(value)} // Handle change event
      />
      <label className="radio-label" htmlFor={`radio-${id}`}>
        {label}
      </label>
    </div>
  );
};

export default RadioButton;
